import color from "../../constants/color";

const styles = {
  dialogSx: {
    "& .MuiDialog-paper": {
      width: "100%",
      maxWidth: "460px",
      borderRadius: "14px",
      margin: "16px",
    },
  },
  container: {
    position: "relative",
    p: 3,
    pt: 4,
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    color: color.lightText,
  },
  iconWrapper: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: 2,
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    color: color.text,
    mb: 1,
  },
  message: {
    fontSize: "14px",
    color: color.lightText,
    lineHeight: 1.5,
  },
  reference: {
    fontSize: "12px",
    color: color.text,
    mt: 2,
    wordBreak: "break-all",
  },
  actionContainer: {
    mt: 3,
    display: "flex",
    justifyContent: "flex-end",
  },
  closeCta: {
    borderRadius: "30px",
    px: 3,
    textTransform: "none",
    fontWeight: 500,
  },
};

export default styles;
